<template>
<div id='body' style='text-align:center; height:100%;'>
<div style='display:inline-block; text-align:left; max-width:600px; width:100%; height:100%;'>
<div style='height: calc(100% - 72px); min-height:300px'>
<table style='height:calc(100%);'><tr><td class="align-middle">
  <div class="panel-heading">
    <div class="panel-title text-center">
      <h1 class="title"><span class="navbar-brand" style='font-size: 35px;'>Мехмат-диск</span></h1>
      <hr />
      <br>
    </div>
  </div>
  <div class="main-login main-center">


  <div v-if="page==0">
    <b-button size="lg" variant="success" @click='gotoPage(3)' v-bind:disabled='disabled'>Преподаватели</b-button>
    <br><br>
    <b-button size="lg" variant="success" @click='gotoPage(1)' v-bind:disabled='disabled'>Студенты</b-button>
    <br><br>
    <b-button size="lg" variant="success" @click='gotoPage(2)' v-bind:disabled='disabled'>Школьники</b-button>
  </div>

  <div v-if="page==1">
    <span style="margin-right:10px"> Форма обучения</span> <b-form-select v-model="selectedStudentType" :options="optionsStudentType" class="mb-3" />
    <br>
    <b-form-select @change.native="number_groups" v-model="selectedStudentCourse" :options="optionsStudentCourse" class="mb-3" />
    <br>
    <b-form-select @change.native="loadFIOList" v-model="selectedGroup"
      :options="optionsStudentGroup" class="mb-3" :disabled="selectedStudentCourse==null" />
    <br>
    <b-form-select v-model="selectedStudentFIOList" :options="FIOList" class="mb-3" :disabled="selectedStudentCourse==null || selectedGroup==null || FIOList.length==1" />
    <b-form-input v-on:keyup.enter="signIn" type="password" v-model="password" placeholder="Пароль" :disabled="selectedStudentCourse==null || selectedGroup==null || selectedStudentFIOList==null || FIOList.length==1"  style='margin-bottom: 1rem;' > </b-form-input>
    <b-button size="lg" variant="success" @click="signIn" v-bind:disabled='selectedStudentCourse==null || selectedGroup==null || selectedStudentFIOList==null || FIOList.length==1'>Войти</b-button>

  </div>

  <div v-if="page==2">
    <b-form-select @change.native="loadFIOList()" v-model="selectedGroup" :options="optionsSchoolGroup" class="mb-3" />
    <br>
    <b-form-select v-model="selectedStudentFIOList" :options="FIOList" class="mb-3" :disabled="selectedGroup==null || FIOList.length==1" />
    <b-form-input v-on:keyup.enter="signIn" type="password" v-model="password" placeholder="Пароль" :disabled="selectedGroup==null || selectedStudentFIOList==null || FIOList.length==1"  style='margin-bottom: 1rem;' > </b-form-input>
    <b-button size="lg" variant="success" @click="signIn" v-bind:disabled='selectedGroup==null || selectedStudentFIOList==null || FIOList.length==1'>Войти</b-button>
  </div>

  <div v-if="page==3">
    <b-form-input v-on:keyup.enter="signIn" v-model="selectedStudentFIOList" name='login' type="text" placeholder="Фамилия Имя Отчество" lazy-formatter></b-form-input><br>
    <b-form-input v-on:keyup.enter="signIn" type="password" v-model="password" placeholder="Пароль" style='margin-bottom: 1rem;' > </b-form-input>
    <b-button size="lg" variant="success" @click="signIn">Войти</b-button>
  </div>

   <b-alert v-bind:show="showAlert" state="danger" @dismissed="showAlert=1">  {{ alertText }} </b-alert>

  </div>
</td></tr></table>
</div>
<footer>
  <img src="./../assets/logo.png"> <a href='http://mmcs.sfedu.ru/'>Институт математики механики и компьютерных наук<br>имени И.И.Воровича</a>
</footer>
</div>
</div>
</template>

<script>
import jQuery from 'jquery'
import {getParameterByName, runServiceCommand} from '../lib/utils'

export default {
  name: 'LoginPage',
  data () {
    return {
      login: '',
      password: '',
      disabled: false,
      showAlert: 0,
      alertText: '',
      page: 0,
      selectedStudentType: 'Дневная',
      optionsStudentType: [
        { value: 'Дневная', text: 'Дневная' },
        { value: 'Вечерняя', text: 'Вечерняя' },
        { value: 'Магистры', text: 'Магистры' }
      ],
      selectedStudentCourse: null,
      optionsStudentCourse: [
        { value: null, text: 'Курс' },
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' }
      ],
      selectedGroup: null,
      optionsStudentGroup: [{value: null, text: 'Группа'}],
      optionsSchoolGroup: [{value: null, text: 'Группа'}],
      selectedStudentFIOList: null,
      FIOList: [{value: null, text: 'Фамилия Имя Отчество'}]
    }
  },
  created () {
    // for (var i = 1; i <= 15; i++) {
    //   this.optionsStudentGroup.push({ value: i, text: i })
    // }
    for (var i = 1; i <= 75; i++) {
      this.optionsSchoolGroup.push({ value: i, text: i })
    }
    window.onpopstate = (e) => {
      this.page = 0
      this.selectedStudentType = 'Дневная'
      this.selectedStudentCourse = null
      this.selectedGroup = null
      this.selectedStudentFIOList = null
      this.FIOList = [{value: null, text: 'Фамилия Имя Отчество'}]
      this.login = ''
      this.password = ''
    }
  },

  methods: {
    gotoPage: function (pageNumber) {
      this.page = pageNumber
      window.history.pushState({}, '', '')
    },

    showError: function (mes) {
      if (!(typeof mes === 'string' || mes instanceof String)) mes = JSON.stringify(mes)
      if (mes === '{}') return
      this.alertText = mes
      this.showAlert = 5
      this.addLog(this.alertText)
    },

    addLog: function (s) { console.log(s) },

    signIn: function () {
      let context = this
      setTimeout(() => {
        var FIO = context.selectedStudentFIOList
        var authType = '&authType='
        switch (context.page) {
          case 1: authType += 'student'; break
          case 2: authType += 'schoolkid'; break
          case 3: authType += 'teacher'; break
          default:
        }
        var studentType = '&studentType=' + context.selectedStudentType
        var course = '&course=' + context.selectedStudentCourse
        var group = '&group=' + context.selectedGroup
        jQuery.get('/login?FIO=' + encodeURIComponent(FIO) + '&password=' + encodeURIComponent(this.password) +
         authType + studentType + course + group, (answer, status) => {
          console.log('answer = ' + answer + '  status = ' + status)
          if (status !== 'success') {
            this.showError('Ошибка при подключении к серверу')
          }
          else {
            if (answer.substring(0, 2) === 'OK') {
              var referer = getParameterByName('referer')
              if (referer === '') window.location = 'showFolder?' + answer.substring(3)
              else window.location = referer
            }
            else {
              this.showError(answer === 'WRONG' ? 'Неправильный пароль' : 'Ошибка на сервере')
            }
          }
          this.disabled = false
        })
      })
    },

    loadFIOList: function () {
      let context = this
      setTimeout(() => {
        var authType = '&authType=' + (context.page === 1 ? 'student' : 'schoolkid')
        var studentType = '&studentType=' + context.selectedStudentType
        var course = '&course=' + context.selectedStudentCourse
        var group = '&group=' + context.selectedGroup
        runServiceCommand('cmd=GET_FIO_LIST' + authType + studentType + course + group).then((FIOList) => {
          context.FIOList.splice(1)
          context.FIOList = context.FIOList.concat(FIOList)
        }).catch(e => context.showError(e))
      })
    },

    number_groups: function () {
      let context = this
      setTimeout(() => {
        var authType = '&authType=' + (context.page === 1 ? 'student' : 'schoolkid')
        var studentType = '&studentType=' + context.selectedStudentType
        var course = '&course=' + context.selectedStudentCourse
        runServiceCommand('cmd=get_number_groups' + authType + studentType + course).then((res) => {
          context.optionsStudentGroup = context.optionsSchoolGroup.slice(0, res.num + 1)
        }).catch(e => context.showError(e))
      })
    }
  }
}
</script>

<style scoped>
#body {background-image: url(./../assets/background.jpg); background-size: cover; background-attachment: fixed;}
button.btn {background-color:#e6f9cf; border-color:#68705e; color:#000; width:100%;}
button.btn:hover {background-color:#68705e; color:#fff;}
.btn.disabled:hover, .btn:disabled {background-color:#e6f9cf; color:#000;}

.custom-select { width:100%; }
.btn.disabled, .btn.disabled:hover, .btn:disabled {opacity:1; background-color: #eceeef;}

.alert-danger { position: absolute; width: calc(100% - 60px); max-width: 538px;}

footer a {color:#fff; text-shadow: 1px 1px 2px #000}
.main-login {background-color: rgba(255,255,255,0.5); padding: 30px;}
</style>
<style>
html, #app, body { font-size:12pt; min-width:320px; height:100%;}
footer {text-align:center}
footer img {float:left;}
table {width:100%;}
</style>



// WEBPACK FOOTER //
// LoginPage.vue?cdb1b866